import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppVersionService } from '../services/app-version.service';

/**
 * Lee el header `X-App-Version` de cada respuesta HTTP del backend y lo pasa
 * al `AppVersionService` para que detecte cuando hay una nueva version del
 * frontend desplegada. Sin polling: aprovecha el trafico que ya genera la app.
 */
@Injectable()
export class AppVersionInterceptor implements HttpInterceptor {
  constructor(private versionService: AppVersionService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const v = event.headers.get('X-App-Version') || event.headers.get('x-app-version');
          if (v) { this.versionService.reportServerVersion(v); }
        }
      })
    );
  }
}
